import {Component, Inject, Input, Optional} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';

export interface SpinnerDialogData {
  message: string;
  diameter?: number;
  subMessage?: string;
}

export class SpinnerDialogConfig extends MatDialogConfig<SpinnerDialogData> {
  override width = 'auto';
  override minWidth = '300px';
  override maxWidth = '600px';
  override disableClose = true;
  override restoreFocus = false;
}

@Component({
  selector: 'creditsnap-spinner-dialog',
  templateUrl: './spinner-dialog.component.html',
})
export class SpinnerDialogComponent {
  @Input() message: string = '';
  @Input() diameter: number = 40;
  @Input() subMessage: string = '';

  constructor(
    public dialogRef: MatDialogRef<SpinnerDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data?: SpinnerDialogData
  ) {
    if (data) {
      this.message = data.message;
      this.diameter = data.diameter || 40;
      this.subMessage = data.subMessage || '';
    }
  }
}
